export default __webpack_public_path__ + "static/media/expressjs.ea97b712.svg";